import React from 'react';
import { styled } from 'linaria/react';
import { Main3DTitle } from '../Elements/Texts/Title3D';
import { Main3DDescription } from '../Elements/Texts/Description3D';

const StyledWrapperStepOne = styled('div')`
    display: flex;
    flex-direction: column;
    margin: 0 auto 4rem;
    `

export const IntroStep = ({ currentStep, setCurrentStep, activeProduct, setActiveProduct, activeCategory, setActiveCategory, activeTextileIndex, setActiveTextileIndex, activeLeg, setActiveLeg }) => {
  return (
    <>
      <StyledWrapperStepOne id="3d-wrapper">
        <Main3DTitle></Main3DTitle>
        <Main3DDescription></Main3DDescription>
      </StyledWrapperStepOne>
    </>
  )
}